import { ColumnProps, SortOrder } from 'antd/lib/table';
import { Sorting } from 'src/types/Sorting';
import { ErrorMessagesList } from '../../../types/QaErrors';

export const defaultPagination = {
  hideOnSinglePage: false,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50'],
  locale: { items_per_page: '' },
};

export type ColumnId = keyof ErrorMessagesList.Item;

export type ColumnSorting = Sorting<ErrorMessagesList.Item> & {
  field: ColumnId;
};

type StandardColumn = ColumnProps<ErrorMessagesList.Item>;
type FilterableColumn = StandardColumn & { dataIndex: ColumnId };
export type ErrorMessagesColumn = FilterableColumn | StandardColumn;

const columns: FilterableColumn[] = [
  {
    title: 'Message',
    dataIndex: 'message',
    sorter: true,
  },
  {
    title: 'Count',
    dataIndex: 'count',
    sorter: true,
  },
];

export const getColumns = (sorting: ColumnSorting): ErrorMessagesColumn[] => {
  const sortOrder = (key: ColumnId): SortOrder | false => {
    return sorting.field === key ? sorting.order : false;
  };
  const filteredColumns = columns.map((column) => ({
    ...column,
    ...(column.sorter && { sortOrder: sortOrder(column.dataIndex) }),
  }));

  return filteredColumns;
};
